import { render, staticRenderFns } from "./PassengerLocationMap.vue?vue&type=template&id=12d2e86f&scoped=true"
import script from "./PassengerLocationMap.vue?vue&type=script&lang=js"
export * from "./PassengerLocationMap.vue?vue&type=script&lang=js"
import style0 from "./PassengerLocationMap.vue?vue&type=style&index=0&id=12d2e86f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2e86f",
  null
  
)

export default component.exports